import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;

  svg{
    animation: fadein 9s linear;
    animation-fill-mode: both;
    opacity: 0;
    @keyframes fadein{
      to{
        opacity: 1;
      }
    }
  }
`

export const Canvas = styled.canvas`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 1;
  animation: fadeout 4s linear;
  animation-delay: 0.5s;
  animation-fill-mode: both;

  @keyframes fadeout{
    to{
      opacity: 0;
    }
  }
`

export const Img = styled.img`
  width: 100%;
  opacity: 0;
`

const Wrapper = styled.div`
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-55%, 20%);
  width: 35%;

  @media (max-width: 700px){
    width: 90%;
  }
`

export default Wrapper;